import React, {useEffect, useState} from 'react';
import {Image, StyleSheet, TouchableOpacity, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {Button, Overlay} from '@rneui/themed';
import {useDevConfigKey} from '../../../hooks/webviewUrl';
import UpgradeTest from './UpgradeTest';
import {fetchQuestionsByRecordId} from '../../../store/xueke';
import {useAppDispatch} from '../../../store/hooks';
export default function FloatDevSetting(): React.JSX.Element {
  const navigation = useNavigation();
  const {config} = useDevConfigKey();
  const [visible, setVisible] = useState(false);

  const dispatch = useAppDispatch();
  const onPress = async () => {
    toggleOverlay();
  };
  const toggleOverlay = () => {
    setVisible(!visible);
  };
  const toPage = (name: string, params?: any) => {
    toggleOverlay();
    //@ts-ignore
    navigation.navigate(name, params);
  };
  return (
    <>
      {config && config.DevSetting ? (
        <TouchableOpacity style={styles.AIWrap} onPress={onPress}>
          <Image
            style={styles.AIWrapImg}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/setting-filling.png',
            }}
          />
        </TouchableOpacity>
      ) : null}
      <Overlay isVisible={visible} onBackdropPress={toggleOverlay}>
        <View style={{width: 200}}>
          {/*<Button onPress={() => toPage('IndexHome')} title="首页" />*/}
          {/*<Button onPress={() => toPage('TakePhotoPage')} title="拍照" />*/}
          {/*<Button onPress={() => toPage('OCREdit')} title="OCR" />*/}
          <Button onPress={() => toPage('Arrangement')} title="整理错提" />
          <Button onPress={() => toPage('Register')} title="注册" />
          <Button onPress={() => toPage('Login')} title="登录" />
          <Button onPress={() => toPage('SysSetting')} title="系统设置" />
          <Button
            onPress={() => toPage('InitialSubjectTest', {subject: 1})}
            title="诊断评测"
          />
          <Button
            onPress={() => toPage('ChatGPTTeacherSelect')}
            title="学科选择"
          />
          <Button
            onPress={() => {
              console.log('点击');
              const testRecordId = 407;
              dispatch(
                fetchQuestionsByRecordId({generateRecordId: testRecordId}),
              )
                .unwrap()
                .then(res => {
                  if (res) {
                    // @ts-ignore
                    navigation.navigate('TestDetails', {
                      recordId: testRecordId,
                    });
                  }
                });
            }}
            title={'首测'}
          />
          <UpgradeTest />
        </View>
      </Overlay>
    </>
  );
}

const styles = StyleSheet.create({
  AIWrap: {
    position: 'absolute',
    zIndex: 999,
    left: 1,
    bottom: '40%',
  },
  AIWrapImg: {
    width: 60,
    height: 60,
  },
});
